import Button from "../../../../components/Buttons/Button";
import TabContainer from "../../../../components/Tab/TabContainer";
import { FaCheck } from "react-icons/fa";
import useSelectBrand from "#hooks/styles/useSelectBrand";
import useReactGASend from "../../../../hooks/useReactGASend";

const RegistForm = ({
  categoryKeys,
  activeTab,
  handleTabClick,
  formData,
  handleEmail,
  handleOnsubmit,
  handleChange,
  emailForm,
  showError,
  loading,
}) => {
  const { color } = useSelectBrand();
  const { makeEventTrackFn } = useReactGASend();
  const trackLinkClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };
  return (
    <form>
      <span className="flex items-center gap-2 mb-2 text-base font-semibold">
        <FaCheck className={`text-${color}`} />
        답변 회신 방법
      </span>
      <TabContainer
        tabs={categoryKeys}
        activeTab={activeTab}
        onTabClick={handleTabClick}
      />

      <div className="mt-5 border-b border-neutral-200"></div>

      <div className="label mt-2.5">
        <span className="text-base font-semibold label-text">점포</span>
      </div>
      <div className="flex items-center h-12 pl-4 text-lg font-medium rounded-lg bg-neutral-100 text-neutral-400">
        {formData?.store_name}
      </div>

      {formData.reply_type === "EMAIL" ? (
        <label className="form-control w-full mt-2.5">
          <div className="label">
            <span className="flex items-center gap-2 text-base font-semibold label-text">
              <FaCheck className={`text-${color}`} /> 답변 수신용 이메일
            </span>
          </div>
          <div className="flex items-center gap-1.5">
            <input
              type="text"
              placeholder=""
              className="w-full font-medium rounded-lg input bg-neutral-100"
              name="id"
              value={emailForm.id}
              onChange={handleEmail}
            />
            @
            <input
              type="text"
              placeholder=""
              className="w-full font-medium rounded-lg input bg-neutral-100"
              name="domain"
              value={emailForm.domain === "직접입력" ? "" : emailForm.domain}
              onChange={handleEmail}
            />
            <select
              className="w-full text-base font-medium rounded-lg select bg-neutral-100 text-neutral-400"
              name="domain"
              value={emailForm.domain}
              onChange={handleEmail}
            >
              <option value="직접입력">직접입력</option>
              <option value="naver.com">naver.com</option>
              <option value="gmail.com">gmail.com</option>
            </select>
          </div>
          {showError.email && (
            <div className="label">
              <span className="text-sm text-red-500 label-text-alt">
                필수입력 사항입니다.
              </span>
            </div>
          )}
        </label>
      ) : (
        <>
          <div className="label mt-2.5">
            <span className="text-base font-semibold label-text">
              휴대폰 번호
            </span>
          </div>
          <div className="flex items-center h-12 pl-4 font-medium rounded-lg bg-neutral-100 text-neutral-400">
            {formData?.phone}
          </div>
        </>
      )}
      <label className="form-control w-full mt-2.5">
        <div className="label">
          <span className="flex items-center gap-2 text-base font-semibold label-text">
            이름
          </span>
        </div>
        <div className="flex items-center gap-1.5">
          <input
            type="text"
            placeholder="이름"
            className="w-full font-medium rounded-lg input bg-neutral-100"
            onChange={(e) => {
              handleChange(e);
            }}
            name="cust_name"
            value={formData.cust_name}
          />
        </div>
      </label>
      <label className="form-control mt-2.5">
        <div className="label">
          <span className="flex items-center gap-2 text-base font-semibold label-text">
            <FaCheck className={`text-${color}`} /> 문의 사항
          </span>
        </div>
        <textarea
          className="text-base font-medium rounded-lg textarea h-28 bg-neutral-100 placeholder:text-neutral-400"
          placeholder="예시) 문의사항 입력을 부탁드립니다."
          onChange={(e) => {
            handleChange(e);
          }}
          name="context"
          value={formData.context}
        ></textarea>
        {showError.context && (
          <div className="label">
            <span className="text-sm text-red-500 label-text-alt">
              필수입력 사항입니다.
            </span>
          </div>
        )}
      </label>
      <div className="mt-10">
        <Button
          arrow
          onClick={(e) => {
            handleOnsubmit(e);
            trackLinkClick("챗봇 VOC 접수");
          }}
        >
          {loading ? (
            <span className="loading loading-dots loading-lg"></span>
          ) : (
            "보내기"
          )}
        </Button>
      </div>
    </form>
  );
};

export default RegistForm;
